import { render, staticRenderFns } from "./AvisoCodigosExportados.vue?vue&type=template&id=2481a325"
import script from "./AvisoCodigosExportados.vue?vue&type=script&lang=js"
export * from "./AvisoCodigosExportados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports